import { observer } from 'mobx-react';
import React from 'react';

const AddNewTemplateDropdownAction = () => {
	return (
		<React.Fragment>
			<i className="fa fa-plus spc--right--tny"></i>
		</React.Fragment>
	);
};

export default observer(AddNewTemplateDropdownAction);
